import { Injectable } from '@angular/core';
import { EnvDomainVariables } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class EnvQAService {
  getDomainInfo(): EnvDomainVariables {
    return {
      _enableErrorLogging: false,
      _enableRefreshToken: false,
      isMagellan: '0',
      _env: 'qa',
      _apiUrl: 'https://qa-api.p-cis.com/api/',
      _production: true,
      _redirectUri: 'https://qa-login.p-cis.com/',
      _responseType: 'token id_token',
      _issuer: 'https://opeekab2cqa.b2clogin.com/1108c96c-8377-4cd6-ae89-9b303f5eab37/v2.0/',
      _strictDiscoveryDocumentValidation: false,
      _tokenEndpoint: 'https://opeekab2cqa.b2clogin.com/opeekab2cqa.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_signin',
      _loginUrl: 'https://opeekab2cqa.b2clogin.com/opeekab2cqa.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_Signin',
      _clientId: '1108c96c-8377-4cd6-ae89-9b303f5eab37',
      _scope: 'openid profile https://opeekab2cqa.onmicrosoft.com/api/opeeka.read',
      _skipIssuerCheck: true,
      _clearHashAfterLogin: true,
      _oidc: true,
      _logoutUrl: 'https://opeekab2cqa.b2clogin.com/opeekab2cqa.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/logout?post_logout_redirect_uri=https://qa-login.p-cis.com',
      _signInURL: 'https://opeekab2cqa.b2clogin.com/opeekab2cqa.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_signin_signup_frp',
      _signInURLSSO: 'https://opeekab2cqa.b2clogin.com/opeekab2cqa.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO',
      _adb2cTenantUrl: 'https://opeekab2cqa.b2clogin.com/opeekab2cqa.onmicrosoft.com/oauth2/v2.0/',
      _magicLink: 'https://opeekab2cdev.b2clogin.com/opeekab2cdev.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_WITH_EMAIL',
      _authEndpoint: 'https://opeekab2cqa.b2clogin.com/opeekab2cqa.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/authorize',
      _magicLinkScope : 'https://opeekab2cqa.b2clogin.com/opeekab2cqa.onmicrosoft.com/B2C_1A_SIGNIN_WITH_EMAIL/oauth2/v2.0/authorize',
      _launchDarklyClientId: '69120006711aa209b78d9aaf',
      _intercomAppId: 'bqgvwybf'
    };
  }
}
